"use client";

import {
  Dialog,
  DialogContent,
} from "~/components/ui/dialog";
import { HireOnboardingAuthPanel } from "~/components/marketplace/hire-onboarding-auth-panel";

type HireOnboardingAuthModalProps = {
  open: boolean;
  phase: "signup" | "verify-email";
  signInUrl: string;
  /** After email-link verification, Clerk must return here to finish org provisioning. */
  hireCompletionRedirectUrl: string;
  initialEmail?: string;
  initialFirstName?: string;
  initialLastName?: string;
  /** Product name in modal copy (SiteGlue vs Inbound GPT). */
  productLabel?: string;
  onVerified: () => void;
};

/** Dialog wrapper around {@link HireOnboardingAuthPanel} (payment / non-SiteGlue flows). */
export function HireOnboardingAuthModal({
  open,
  phase,
  signInUrl,
  hireCompletionRedirectUrl,
  initialEmail,
  initialFirstName,
  initialLastName,
  productLabel = "Inbound GPT",
  onVerified,
}: HireOnboardingAuthModalProps) {
  return (
    <Dialog open={open} onOpenChange={() => {}}>
      <DialogContent
        className="max-h-[90vh] max-w-md gap-0 overflow-y-auto p-0 sm:max-w-lg"
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        {open ? (
          <HireOnboardingAuthPanel
            phase={phase}
            signInUrl={signInUrl}
            hireCompletionRedirectUrl={hireCompletionRedirectUrl}
            initialEmail={initialEmail}
            initialFirstName={initialFirstName}
            initialLastName={initialLastName}
            productLabel={productLabel}
            className="min-h-0"
            onVerified={onVerified}
          />
        ) : null}
      </DialogContent>
    </Dialog>
  );
}
